import { createApp } from 'vue'
import App from './App.vue'
import router from './router' // Importa el router
import './assets/styles/main.css'

const app = createApp(App)

app.use(router) // Dile a Vue que use el router

app.mount('#app')
